import React from 'react';
import { useNavigate } from 'react-router-dom';

import RotatingSphere from './RotatingSphere';

const StaticHeroSection = () => {
  const navigate = useNavigate();

  const handleAboutClick = () => {
    navigate('/post-poster');
  };

  return (
    <section className='pt-0 pb-36 min-h-[calc(75vh+4rem)] relative overflow-hidden'>
      {/* 旋轉球體動畫背景 */}
      <div className='absolute inset-0'>
        <RotatingSphere />
      </div>

      {/* Post a Poster 按鈕 - 位於整個DIV的最上方 */}
      <div className='absolute top-12 left-0 right-0 z-10 bg-transparent'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center'>
          <button
            onClick={handleAboutClick}
            className='bg-black text-white px-8 py-3 rounded-md text-lg font-medium border border-transparent transition-all duration-300 pointer-events-auto hover:bg-gradient-to-r hover:from-blue-500 hover:to-purple-500 hover:border-transparent hover:-translate-y-1 hover:shadow-xl'
          >
            Post a Poster
          </button>
        </div>
      </div>
    </section>
  );
};

export default StaticHeroSection;
